<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Garantias</b>
            </h3>
          </div>
          <div class="box-body">
           <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="empresa">Loja</label>
                  <v-select v-model="empresaSelecionada" :options="empresas" placeholder="TODAS"></v-select>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="situacao">Situação</label>
                  <select class="form-control" v-model="dados.situacao">
                    <option value>TODAS</option>
                    <option value="APROVADO">APROVADO</option>
                    <option value="CANCELADO">CANCELADO</option>
                    <option value="NÃO AUTORIZADO">NÃO AUTORIZADO</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label for="">Duplicatas</label>
                  <select class="form-control" v-model="dados.possui_duplicata">
                    <option value="">COM E SEM DUPLICATAS ANEXADAS</option>
                    <option value="0">SOMENTE SEM DUPLICATAS ANEXADAS</option>
                    <option value="1">SOMENTE COM DUPLICATAS ANEXADAS</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-10">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                />
              </div>
              <div class="col-md-2">
                <button @click="getDataTable" class="btn btn-default btn-block"><i class="fa fa-filter"></i> Filtrar</button>
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 10%">Protocolo</th>
                      <th style="width: 16%">Data</th>
                      <th style="width: 18%">Loja</th>
                      <th style="width: 17%">Pessoa</th>
                      <th style="width: 12%">Cpf/Cnpj</th>
                      <th style="width: 5%">Qtd.</th>
                      <th style="width: 14%">Situação</th>
                      <th style="width: 8%">Ṕossui Duplicata?</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="even selecionavel"
                      role="row"
                      v-for="item in apiData.data"
                      :key="item.id"
					  @click="showDetalhe(item.id)"
                    >
                      <td>{{ item.id }}-{{ item.digito }}</td>
                      <td>{{ item.data | dataHoraFormatada }}</td>
                      <td>{{ item.usuario.empresa.fantasia }}</td>
                      <td>{{ item.pessoa.nome_razao }}</td>
                      <td>{{ item.pessoa.cpf_cnpj }}</td>
                      <td>{{ item.qtd_titulo }}</td>
                      <td><strong :class="item.status">{{ item.status }}</strong></td>
                       <td>{{ item.possui_duplicata == 1 ? 'Sim' : 'Não' }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vSelect from "vue-select";
export default {

  data: () => ({
     empresas: [],
    empresaSelecionada: null,
    dados: {
      pesquisa: "",
      situacao: '',
      empresa_id: '',
      possui_duplicata: ''
    },
    apiData: {
      data: []
    }
  }),
  mounted() {
    this.getDataTable();
     this.getEmpresas();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
     getEmpresas() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/empresa/dataForSelect`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          console.log(response.data);
          this.empresas = response.data;
        });
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/getAllPaginate`,
          config
        )
        .then(response => {
          console.log(response);
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
	},
	showDetalhe(garantiaId) {
		this.$router.push(`/operacao/garantias/detalhe/${garantiaId}`);
	}
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    },
     empresaSelecionada: function(val) {
       if (val) {
         this.dados.empresa_id = val.value;
       } else {
         this.dados.empresa_id = '';
       }
        
    }
  },

  components: {
    vSelect
  }
};
</script>
<style scoped>
.selecionavel {
	cursor: pointer;
}
.selecionavel:hover {
	background-color: #ddd;
}

td {
  text-transform: uppercase;
}

.APROVADO {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// index.vue?624da812